import type { AppRouterPaths } from "./types";
import { appRouterPaths } from "./urls";

export const getServicePagePath = (
  id: string | null,
  pathName: keyof AppRouterPaths
): string => {
  const routeConfig = appRouterPaths[pathName];
  if (id && routeConfig.item) {
    return routeConfig.item.replace(":id", id);
  } else {
    return routeConfig.root;
  }
};
